import React from 'react';
import { Link } from 'react-router-dom';
import NewModal from 'react-responsive-modal';
import PropTypes from 'prop-types';

const InventoryAlertModal = ({ isOpen, onClose, action = 'remove', userHash }) => {
  const getActionText = () => {
    switch (action) {
      case 'lock':
        return {
          title: 'Error: Remove Inventory First',
          message: 'In order to lock this employee you need to remove their inventory first'
        };
      case 'remove':
      default:
        return {
          title: 'Error: Remove Inventory First',
          message: 'In order to remove this employee you need to remove their inventory first'
        };
    }
  };

  const { title, message } = getActionText();

  // Create inventory URL with user hash parameter for filtering
  const inventoryUrl = userHash ? `/inventory?user=${userHash}` : '/inventory';

  return (
    <NewModal
      id='remove_popup'
      className='status_popup'
      open={isOpen}
      onClose={onClose}
      little
    >
      <div id='removePopup'>
        <div className='modal-head'>
          <h4 className='modal-title'>{title}</h4>
        </div>
        <div className='modal-body'>
          <label>
            {message}
          </label>
          <br />
          <Link to={inventoryUrl}>
            <button className='button'>Go to inventory</button>
          </Link>
          <button className='button grey' onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </NewModal>
  );
};

InventoryAlertModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  action: PropTypes.string,
  userHash: PropTypes.string,
};

export default InventoryAlertModal;
